import { render, staticRenderFns } from "./select-payment.vue?vue&type=template&id=3bfa31e3&"
import script from "./select-payment.vue?vue&type=script&lang=js&"
export * from "./select-payment.vue?vue&type=script&lang=js&"
import style0 from "./select-payment.vue?vue&type=style&index=0&id=3bfa31e3&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports